import { render, staticRenderFns } from "./unit-details.vue?vue&type=template&id=6ed50cfc&"
import script from "./unit-details.vue?vue&type=script&lang=js&"
export * from "./unit-details.vue?vue&type=script&lang=js&"
import style0 from "./unit-details.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports